import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { LAST_UPDATED } from '../../data/legal/company';
import { LegalNav } from './LegalNav';
import { LegalSection } from './LegalSection';

const HEADER_INITIAL = { opacity: 0, y: 24 };
const HEADER_ANIMATE = { opacity: 1, y: 0 };
const HEADER_TRANSITION = { duration: 0.6 };
const UPDATED_LABEL = { tr: 'Son güncelleme', en: 'Last updated' };

export default function LegalPage({ doc }) {
  const { language } = useLanguage();
  const content = doc.content[language];

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [doc.key]);

  return (
    <main className="min-h-screen bg-slate-900 pt-36 md:pt-44 pb-24" data-testid={`legal-page-${doc.key}`}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-[240px_1fr] gap-10 lg:gap-16">
        <LegalNav language={language} />
        <article>
          <motion.header initial={HEADER_INITIAL} animate={HEADER_ANIMATE} transition={HEADER_TRANSITION} className="mb-6">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-orange-500/10 border border-orange-500/30 mb-6">
              <ShieldCheck className="w-4 h-4 text-orange-400" />
              <span className="text-xs text-orange-300 font-medium" data-testid="legal-updated">
                {UPDATED_LABEL[language]}: {LAST_UPDATED[language]}
              </span>
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6" data-testid="legal-title">
              {content.title}
            </h1>
            <p className="text-base md:text-lg text-gray-400 leading-relaxed max-w-3xl">{content.intro}</p>
          </motion.header>
          {content.sections.map((section, i) => (
            <LegalSection key={section.heading} section={section} index={i} />
          ))}
        </article>
      </div>
    </main>
  );
}
